<div class="card mt-0 mb-2">
  <div class="card-body p-1 pr-4 pt-3">
    <div class="form-row px-3">
      <!-- <div class="col-lg-3 col-md-6 mb-1 d-flex align-items-center"> -->
      <!-- <small class="font-weight-bold" style="width: 160px">Selected Year:
        </small>
        <angular2-multiselect [data]="YearList" [(ngModel)]="selectedYear" [settings]="dropdownSetting"
          (onSelect)="onYearSelect($event)" (onDeSelect)="onYearSelect($event)" (onSelectAll)="onYearSelect($event)"
          (onDeSelectAll)="onYearSelect($event)" fixSearchBug style="width: 100%">
        </angular2-multiselect> -->
      <div class="col-xl-2 col-lg-6 mb-2">
        <small class="same-height-label-1">Business Vertical</small>
        <angular2-multiselect [settings]="businessVerticalDropdownSetting" [data]="businessVertical"
          [(ngModel)]="selectedBusinessVertical" (onSelect)="onBusinessSelect($event)"
          (onDeSelect)="onBusinessSelect($event)" (onSelectAll)="onBusinessSelect($event)"
          (onDeSelectAll)="onBusinessSelect($event)" fixSearchBug>
        </angular2-multiselect>
      </div>
      <div class="col-xl-2 col-lg-6 mb-2" *ngIf="
              Account == 'true' ||
              Finance == 'true' ||
              General == 'true' ||
              Sales == 'true' ||
              Service == 'true' ||
              roleId == 1
            ">
        <small class="same-height-label-1">Sales Engineer</small>
        <angular2-multiselect [settings]="salesEnggDropdownSetting" [data]="salesQuotationEngg"
          [(ngModel)]="selectedSalesEngg" (onSelect)="onSalesEnggSelect($event)"
          (onDeSelect)="onSalesEnggSelect($event)" (onSelectAll)="onSalesEnggSelect($event)"
          (onDeSelectAll)="onSalesEnggSelect($event)" fixSearchBug>
        </angular2-multiselect>
      </div>
      <div class="col-xl-2 col-lg-6 mb-2" *ngIf="
              Account == 'true' ||
              Finance == 'true' ||
              General == 'true' ||
              Sales == 'true' ||
              Service == 'true' ||
              roleId == 1
            ">
        <small class="same-height-label-1">Quotation Engineer</small>
        <angular2-multiselect [settings]="quotEnggDropdownSetting" [data]="salesQuotationEngg"
          [(ngModel)]="selectedQuotationEngg" (onSelect)="onQuotationEnggSelect($event)"
          (onDeSelect)="onQuotationEnggSelect($event)" (onSelectAll)="onQuotationEnggSelect($event)"
          (onDeSelectAll)="onQuotationEnggSelect($event)" fixSearchBug>
        </angular2-multiselect>
      </div>
      <div class="col-xl-2 col-lg-6 mb-2">
        <small class="same-height-label-1">Probability</small>
        <angular2-multiselect [settings]="probabilitySetting" [data]="probability" [(ngModel)]="selectedProbability"
          (onSelect)="onProbabilitySelect($event)" (onDeSelect)="onProbabilitySelect($event)"
          (onSelectAll)="onProbabilitySelect($event)" (onDeSelectAll)="onProbabilitySelect($event)" fixSearchBug>
        </angular2-multiselect>
      </div>
      <div class="col-xl-2 date-filter-field-2 date-filter-last-field col-lg-6 mb-2 mb-xl-2">
        <small class="same-height-label-1">Select Date Range:</small>
        <div class="w-100 position-relative">
          <input class="form-control" type="text" [showDropdowns]="true" ngxDaterangepickerMd (keydown)="disableDate()"
            [(ngModel)]="date_range" [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges"
            [ngModelOptions]="{ standalone: true }" [showClearButton]="true" placeholder="DD-MM-YYYY" />
          <span class="position-absolute" style="top: 48%; right: -5px; transform: translate(-50%, -50%)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x"
              viewBox="0 0 16 16" (click)="clearEndDate()">
              <path
                d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </span>
        </div>
      </div>

      <div class="col-auto mb-2 d-flex align-items-center pt-3">

        <a href="javascript:void(0);" type="submit"
          class="btn btn-outline-info d-flex align-items-center btn-new-light-info mr-3 mediaMargin" title="Apply"
          (click)="applyFilter()">
          <i class="mdi mdi-checkbox-marked-outline mdi-18px"></i> </a>
        <a href="javascript:void(0);"
          class="btn btn-outline-info d-flex align-items-center btn-new-light-info mediaMargin" title="Reset"
          (click)="resetData()">
          <i class="mdi mdi-reload mdi-18px"></i></a>
      </div>
    </div>
  </div>
</div>
<div class="card">
  <div class="card-body p-0">
    <div class="card shadow-sm">
      <div class="card-body py-2">
        <h4 class="text-center font-weight-bold heading-bold">Inquiry Info</h4>
        <div class="row">
          <div class="col-md-4 mb-2">
            <div class="card h-100 shadow-none rounded-sm border">
              <div class="card-body d-flex align-items-center p-0">
                <div class="w-25 d-flex align-items-center justify-content-center">
                  <span class="rounded-circle p-2 bg-info text-white"><span style="font-size: 2rem; display: contents"
                      class="mdi mdi-pencil"></span></span>
                </div>

                <div class="w-75">
                  <h4>Inquiry Created</h4>
                  <!-- <div class="progress">
                                          <div class="progress-bar progress-bar-striped bg-info" role="progressbar"
                                              style="width: 30%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div> -->
                  <span>
                    <h5 class="my-2">
                      <span class="font-weight-bold">{{ InquiryCreated }}</span>
                      ({{ CreatedValue | number : "1.2-2" }})
                    </h5>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-2">
            <div class="card h-100 shadow-none rounded-sm border">
              <div class="card-body d-flex align-items-center p-0">
                <div class="w-25 d-flex align-items-center justify-content-center">
                  <span class="rounded-circle p-2 bg-info text-white"><span style="font-size: 2rem; display: contents"
                      class="mdi mdi-transcribe-close"></span></span>
                </div>

                <div class="w-75">
                  <h4>Inquiry Closing</h4>
                  <!-- <div class="progress">
                                          <div class="progress-bar progress-bar-striped bg-info" role="progressbar"
                                              style="width: 10%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div> -->
                  <span>
                    <h5 class="my-2">
                      <span class="font-weight-bold">{{ InquiryClosing }}</span>
                      ({{ ClosingValue | number : "1.2-2" }})
                    </h5>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 mb-2">
            <div class="card h-100 shadow-none rounded-sm border">
              <div class="card-body d-flex align-items-center p-0">
                <div class="w-25 d-flex align-items-center justify-content-center">
                  <span class="rounded-circle p-2 bg-info text-white"><span style="font-size: 2rem; display: contents"
                      class="mdi mdi-clock-alert"></span></span>
                </div>

                <div class="w-75">
                  <h4>Over Due Inquiry</h4>
                  <!-- <div class="progress">
                                          <div class="progress-bar progress-bar-striped bg-info" role="progressbar"
                                              style="width: 80%" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>
                                      </div> -->
                  <span>
                    <h5 class="my-2">
                      <span class="font-weight-bold">{{ OverdueInquiry }}</span>
                      ({{ OverdueValue | number : "1.2-2" }})
                    </h5>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row w-100 m-0">
      <div class="col-md-5 pr-0">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="YearlyBookingVsAchieveChartOption" class="gauge-container" [theme]="selectedTheme">
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="MonthlyBookingVsAchieveChartOption" class="common-container"
              [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6 pr-0">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="ExpectedOrdersChartOption" class="common-container" [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="PipeLineByStageChartOption" class="common-container" [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6 pr-0">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="OpenInquiriesChartOption" class="common-container" [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="LostInquiriesChartOption" class="common-container" [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6 pr-0">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <div echarts [options]="OrdersByMTIChartOption" class="common-container" [theme]="selectedTheme"></div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <h4 class="text-center font-weight-bold heading-bold">
              Top Sales Products
            </h4>
            <div class="tbl-container">
              <table class="table table-mini-th" aria-describedby="TopSalesProducts">
                <th class="p-1 font-12">Product</th>
                <th class="p-1 font-12">Count</th>
                <th class="p-1 font-12">Reported Value</th>
                <tr *ngFor="let item of TopSalesProductsList">
                  <td>{{ item.Code }}</td>
                  <td class="text-right">{{ item.SalesCount }}</td>
                  <td class="text-right">
                    {{ item.Salesvalue | number : "1.2-2" }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <h4 class="text-center font-weight-bold heading-bold">
              Inquiry By Project Source
            </h4>
            <div class="tbl-container">
              <table class="table table-mini-th" aria-describedby="mydesc">
                <th class="p-1 font-12">ProjectSource</th>
                <th class="p-1 font-12">Count</th>
                <th class="p-1 font-12">Reported Value</th>
                <tr *ngFor="let item of InquiryByProjectSourceList">
                  <td>{{ item.ProjectSource }}</td>
                  <td class="text-right">{{ item.InquiryCount }}</td>
                  <td class="text-right">
                    {{ item.ReportedValue | number : "1.2-2" }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 pr-0">
        <div class="card shadow-sm mb-3">
          <div class="card-body">
            <h4 class="text-center font-weight-bold heading-bold">
              Inquiry By Application
            </h4>
            <div class="tbl-container">
              <table class="table table-mini-th" aria-describedby="mydesc">
                <th class="p-1 font-12">Application</th>
                <th class="p-1 font-12">Count</th>
                <th class="p-1 font-12">Reported Value</th>
                <tr *ngFor="let item of InquiryByApplicationList">
                  <td>{{ item.Name }}</td>
                  <td class="text-right">{{ item.InquiryCount }}</td>
                  <td class="text-right">
                    {{ item.ReportedValue | number : "1.2-2" }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ngx-spinner type="ball-scale-multiple"></ngx-spinner>